import * as CSS from 'csstype'

// Default element colors
export var defaultBorderStyle = 'solid'
export var defaultBorderWidth = 1
export var defaultBorderColor: CSS.Property.BorderStyle  = '#ff0000'
export var defaultBorderBoxSizing: CSS.Property.BoxSizing = 'border-box'
